<template>
    <v-navigation-drawer
        v-model="questionNavigator"
        app
        right
        clipped
    >
        <v-row
            align="center"
            class="mt-4 mx-0 px-4 px-lg-0 justify-space-between justify-lg-center"
        >
            <v-switch
                v-model="autoScroll"
                label="Auto scroll"
                hide-details
                inset
                color="primary"
                class="mt-0"
            ></v-switch>
            <v-btn
                @click="questionNavigator = false"
                icon
                class="d-lg-none"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-row>

        <v-row
            justify="center"
            class="mx-0 mt-4"
        >
            <div
                v-for="(question, idx) in questions"
                :key="idx"
                @click="changeActiveIdx(idx)"
                class="questionitem elevation-2"
                :class="{
                    'questionitem--active': idx === activeQuestionIdx,
                    'questionitem--flagged': $store.get(
                        `tryout/answers@${idx}.flagged`
                    ),
                    'questionitem--answered': !!$store.get(
                        `tryout/answers@${idx}.answer_id`
                    ),
                }"
            >
                <div class="mt-3">
                    {{ idx + 1 }}
                </div>
            </div>
        </v-row>
    </v-navigation-drawer>
</template>

<script>
import { sync, get } from 'vuex-pathify'

export default {
    computed: {
        autoScroll: sync('tryout/autoScroll'),
        questionNavigator: sync('tryout/questionNavigator'),
        questions: get('tryout/questions'),
        activeQuestionIdx: get('tryout/activeQuestionIdx'),
    },

    methods: {
        changeActiveIdx(idx) {
            this.$store.set('tryout/activeQuestionIdx', idx)
            this.$tracking.event.tryout.questionChange(
                `${this.$store.get('tryout/title')} ${this.$store.get(
                    'enrollment/selected@title'
                )}`,
                idx + 1
            )

            if (this.$vuetify.breakpoint.mdAndDown) {
                this.questionNavigator = false
            }
        },
    },
}
</script>
